import React from 'react';
import { Route } from 'react-router-dom';
import RedditBuzzPage from 'modules/reddit/pages/RedditBuzzPage';
import RedditTickerView from 'modules/reddit/pages/RedditTickerView';
import redditReducer from 'modules/reddit/features/redditSlice';

/**
 * Modul-Definition "Reddit-Buzz".
 *
 * Einziger Export des Moduls an das Portal (Registry in modules/index.js).
 */
const redditModul = {
  id: 'reddit-buzz',
  name: 'Reddit-Buzz',
  description:
    'Wie oft und intensiv über Aktien auf Reddit diskutiert wird – mit Verlauf.',
  path: '/projekte/reddit-buzz',
  icon: '👽',
  gradient: 'from-orange-400 to-rose-600',
  status: 'active',
  reducers: {
    reddit: redditReducer,
  },
  routes: (
    <React.Fragment>
      <Route path="/projekte/reddit-buzz" element={<RedditBuzzPage />} />
      <Route path="/projekte/reddit-buzz/:ticker" element={<RedditTickerView />} />
    </React.Fragment>
  ),
};

export default redditModul;
